import TextField from '@mui/material/TextField';
import styled from 'styled-components';

export const StyledMainContainer = styled.div`
    display: flex;
    flex-direction: row;
    width: 446px;
    gap: 16px;
    align-items: baseline;
`;

export const StyledAlignedEndInput = styled(TextField)`
    display: flex;

    #required-input {
        text-align: end;
    }
`;

export const StyledInputLabel = styled.p`
    color: #223554;

    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
`;

export const StyledInputSubLabel = styled.p`
    color: #909aa9;

    text-align: right;
    font-family: Inter;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px; /* 220% */
`;

export const StyledDivArrow = styled.p`
    display: flex;
    gap: 3px;
    margin-top: 0px;
    margin-bottom: 10px;
`;

export const StyledSubLabelArrow = styled.p`
    color: #5b5b5b;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 600;
    margin: 0px;
`;
